import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text/Text'
import palette from 'core-system/Themes/palette'
import Request from 'redux/config/services/Request'
import ReportedUsageContent, { ReportedUsageData } from './ReportedUsageContent'

const Container = styled.div`
  padding: 2rem;
`

const ReportedUsageView = () => {
  const [data, setData] = useState<ReportedUsageData | null>(null)
  const [error, setError] = useState('')

  useEffect(() => {
    Request.get('/mobile/reported_usage/me/')
      .then((response) => setData(response.data))
      .catch(() => setError('Could not load your usage.'))
  }, [])

  return (
    <Container>
      {error ? (
        <Text variant='body1'>{error}</Text>
      ) : data ? (
        <ReportedUsageContent data={data} />
      ) : (
        <Text variant='body1' color={palette.text.secondary}>
          Loading…
        </Text>
      )}
    </Container>
  )
}

export default ReportedUsageView
